export const CheckboxIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      height="16"
      rx="5"
      stroke="currentColor"
      strokeWidth="2"
      width="16"
      x="4"
      y="4.5"
    />
  </svg>
);
